<template>
    <v-container>
        <FormularioCadastroEmailAnaliseCredito
                :email-edicao="email_para_editar"
                @limpaEmailEdicao="limpaEmailEdicao"
                @registroInserido="registroInserido"
        />
        <ListagemEmailsAnaliseCredito @editar="editarEmail" :atualiza-listagem="atualiza_listagem" />
    </v-container>
</template>

<script>
  import FormularioCadastroEmailAnaliseCredito from '@/components/email-analise-credito/FormularioCadastroEmailAnaliseCredito.vue'
  import ListagemEmailsAnaliseCredito from '@/components/email-analise-credito/ListagemEmailsAnaliseCredito.vue'

  export default {
    name: 'ConfigCreditAnalysisEmail',
    components: {
      FormularioCadastroEmailAnaliseCredito,
      ListagemEmailsAnaliseCredito
    },
    data () {
      return {
        email_para_editar: null,
        atualiza_listagem: false
      }
    },
    methods: {
      limpaEmailEdicao () {
        this.email_para_editar = null
      },
      editarEmail (item) {
        this.email_para_editar = item
      },
      registroInserido () {
        this.atualiza_listagem = !this.atualiza_listagem
      }
    }
  }
</script>
